import { useState } from "react";
import Layout from "../components/Layout";
import { useCartContext } from "../context/CartContext";
import { Link } from "react-router-dom";
import { getBkendUrl, getRootUrl } from "../../consts";
import axios_with_token from "../../axios_with_token";
import axios from "axios";

import { addTblRcds } from "../../axios_with_token";

import { useLoginContext as usewwAppLoginContext } from "../context/LoginContext";


function CartContent(){
  const rootUrl = getRootUrl();
  const bkEndUrl = getBkendUrl();

  const {items, addItem, removeItem, updateItem, clearCart, totalPrice} = useCartContext();
  const [stdDlvCost, setStdDlvCost] = useState(100.0);
  const [expDlvCost, setExpDlvCost] = useState(150.0);
  const [shipping, setShipping] = useState('standard');
  
  const taxRatio = 0.13;
  const amountBeforeTax = parseFloat(totalPrice)>0?(parseFloat(totalPrice) + parseFloat((shipping=='standard')?stdDlvCost:expDlvCost)):0;
  const tax = amountBeforeTax * taxRatio;
  const amountAfterTax = amountBeforeTax * (1+taxRatio);

  const {userInfo:wwAppUserInfo} = usewwAppLoginContext();

  {/* <!-- Page Title --> */}
  return <><div className="page-title light-background">
    <div className="container d-lg-flex justify-content-between align-items-center">
      <h1 className="mb-2 mb-lg-0">Cart</h1>
      <nav className="breadcrumbs">
        <ol>
          <li><a href="index.html">Home</a></li>
          <li className="current">Cart</li>
        </ol>
      </nav>
    </div>
  </div>
  {/* <!-- End Page Title --> */}

  {/* <!-- Cart Section --> */}
  <section id="cart" className="cart section">

    <div className="container" data-aos="fade-up" data-aos-delay="100">

{/* Name	Product Code	Unit Price	Units / Case	Price / Case	Cases */}
      <div className="row">
        <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
          <div className="cart-items">
            <div className="cart-header d-none d-lg-block">
              <div className="row align-items-center">
                <div className="col-lg-5">
                  <h5>Product</h5>
                </div>
                {/* <div className="col-lg-2 text-center">
                  <h5>Price</h5>
                </div> */}
                {/* <div className="col-lg-2 text-center">
                  <h5>units / Case</h5>
                </div> */}
                <div className="col-lg-2 text-center">
                  <h5>Price / Case</h5>
                </div>
                <div className="col-lg-3 text-center">
                  <h5>Cases</h5>
                </div>
                <div className="col-lg-2 text-center">
                  <h5>Total</h5>
                </div>
              </div>
            </div>

            {/* <!-- Cart Items --> */}
            {items.map(item=><div
              className="cart-item"
              key={Math.random()}
            >
              <div className="row align-items-center">
                <div className="col-lg-5 col-12 mt-3 mt-lg-0 mb-lg-0 mb-3">
                  <div className="product-info d-flex align-items-center">
                    <div className="product-image">
                      <img src={item.images[0].url} alt="Product" className="img-fluid" loading="lazy" />
                    </div>
                    <div className="product-details">
                      <h6 className="product-title">{`[${item.sn}] ${item.name}`}</h6>
                      {/* <div className="product-meta">
                        <span className="product-color">Color: Black</span>
                        <span className="product-size">Size: M</span>
                      </div> */}
                      <button className="remove-item" type="button"
                        onClick={evt=>removeItem(item.__id)}
                      >
                        <i className="bi bi-trash"></i> Remove
                      </button>
                      <Link className="remove-item ms-3" type="button"
                        to={`${rootUrl}/wwapp/productdetails/${item.__id}`}
                      >
                        <i className="bi bi-eye"></i> detail
                      </Link>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-2 col-12 mt-3 mt-lg-0 text-center">
                  <div className="price-tag">
                    {item.price&&<span className="current-price">${item.price}</span>}
                  </div>
                </div> */}
                {/* <div className="col-lg-2 col-12 mt-3 mt-lg-0 text-center">
                  <div className="price-tag">
                    <span>{item.unitsPerCase}</span>
                  </div>
                </div> */}
                <div className="col-lg-2 col-12 mt-3 mt-lg-0 text-center">
                  <div className="price-tag">
                    {item.price&&<span>${(item.unitsPerCase * item.price).toFixed(2)}</span>}
                  </div>
                </div>                     
                <div className="col-lg-3 col-12 mt-3 mt-lg-0 text-center">
                  <div className="quantity-selector">
                    <button className="quantity-btn decrease"
                      onClick={evt=>updateItem(item.__id, Math.max(item.unitsPerCase, item.qty-parseInt(item.unitsPerCase)))}
                    >
                      <i className="bi bi-dash"></i>
                    </button>
                      <input _type="number" className="quantity-input"
                        value={item.qty / item.unitsPerCase} _min="1" _max="10"
                        size="48"
                        style={{"width":"5em"}} 
                        onChange={evt=>updateItem(item.__id, evt.target.value * item.unitsPerCase)}
                      />
                    <button className="quantity-btn increase"
                      onClick={evt=>updateItem(item.__id, Math.max(item.unitsPerCase, item.qty+parseInt(item.unitsPerCase)))}
                    >
                      <i className="bi bi-plus"></i>
                    </button>
                  </div>
                </div>
                <div className="col-lg-2 col-12 mt-3 mt-lg-0 text-center">
                  <div className="item-total">
                    <span>${(item.price * item.qty).toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>)}
            {/* <!-- End Cart Item --> */}

            <div className="cart-actions">

              <div className="row">
                <div className="col-lg-6 mb-3 mb-lg-0">
                  {/* <div className="coupon-form">
                    <div className="input-group">
                      <input type="text" className="form-control" placeholder="Coupon code" />
                      <button className="btn btn-outline-accent" type="button">Apply Coupon</button>
                    </div>
                  </div> */}
                </div>

                <div className="col-lg-6 text-md-end">
                  {/* <button className="btn btn-outline-heading me-2">
                    <i className="bi bi-arrow-clockwise"></i> Update Cart
                  </button> */}
                  <button className="btn btn-outline-remove"
                    onClick={evt=>{
                      if(window.confirm("Confirm to clear the cart?")){
                        clearCart();
                      }
                    }}
                  >
                    <i className="bi bi-trash"></i> Clear Cart
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="300">
          <div className="cart-summary">
            <h4 className="summary-title">Order Summary</h4>

            <div className="summary-item">
              <span className="summary-label">Subtotal</span>
              <span className="summary-value">${totalPrice.toFixed(2)}</span>
            </div>

            <div className="summary-item shipping-item">
              <span className="summary-label"><strong>Shipping Fee</strong> may be added after order is placed and confirmed.</span>
              {/* <div className="shipping-options"> */}

                {/* <div className="form-check text-end">
                  <input className="form-check-input" type="radio" name="shipping" id="standard" 
                    value={"standard"}
                    checked={shipping==="standard"}
                    onChange={evt=>{
                      console.log(evt.target.value);
                      setShipping(evt.target.value);
                    }}
                  />
                  <label className="form-check-label" htmlFor="standard">
                    Standard Delivery - ${stdDlvCost.toFixed(2)}
                  </label>
                </div> */}

                {/* <div className="form-check text-end">
                  <input className="form-check-input" type="radio" name="shipping" id="express" 
                    value={"express"}
                    checked={shipping==="express"}
                    onChange={evt=>setShipping(evt.target.value)}
                  />
                  <label className="form-check-label" htmlFor="express">
                    Express Delivery - ${expDlvCost.toFixed(2)}
                  </label>
                </div> */}

                {/* <div className="form-check text-end">
                  <input className="form-check-input" type="radio" name="shipping" id="free" />
                  <label className="form-check-label" htmlFor="free">
                    Free Shipping (Orders over $300)
                  </label>
                </div> */}

              {/* </div> */}

            </div>

            <div className="summary-item">
              <span className="summary-label"><strong>Tax</strong> will be added after order is placed and confirmed. </span>
              {/* <span className="summary-label">Tax (HST - {((taxRatio*100).toFixed(2))}%)</span> */}
              {/* <span className="summary-value">${tax.toFixed(2)}</span> */}
            </div>

            {/* <div className="summary-item discount">
              <span className="summary-label">Discount</span>
              <span className="summary-value">-$0.00</span>
            </div> */}

            <div className="summary-total">
              <span className="summary-label">Total</span>
              {/* <span className="summary-value">${amountAfterTax.toFixed(2)}</span> */}
              <span className="summary-value">{totalPrice.toFixed(2)}</span>
            </div>

            <div className="checkout-button">
              <button type="button" className="btn btn-accent w-100"
                onClick={evt=>{
                  const placeOrderUrl = `${bkEndUrl}/jwt/contact`;
                  const orderRcd = {
                    sn: Date.now(),
                    date: (new Date()).toISOString().split('T')[0], //Date(Date.now()),
                    client: wwAppUserInfo.__id
                  };
                  const orderItemRcds =  items.map(pdt=>({
                        // orderId:
                        pdtId: pdt.__id,
                        unitPrice: pdt.price,
                        unitsPerCase: pdt.unitsPerCase,
                        qty: pdt.qty
                  }));

                  console.log(orderRcd, orderItemRcds);

                  addTblRcds(
                    'wwAppOrders',
                    [orderRcd], 
                    {
                      "wwAppOrderItems":{
                        connectFld: "orderId",
                        rcds:orderItemRcds
                      }
                    }
                  ).then(res=>{
                    if(window.confirm('order placed. clear the cart?')){
                      clearCart();
                    }
                  });

                  if(false){
                    // try {
                          // 👉 Adjust the URL if your Flask API lives on a different host/port
                          axios.post(
                            // If you deploy Flask to the same origin, you can just use a relative path:
                            // "/api/contact"
                            placeOrderUrl,
                            {
                              "name": "Martin",
                              "email": "martin@willowest.com;rainzhang@willowest.com",
                              "subject": "new order from wwapp",
                              "message": [
                                items.map(item=>`[${item.sn}] ${item.name} - ${item.brandAbbr}: ${item.qty} unit, $${item.price} each`).join("\n"),
                                `amount: ${totalPrice}`
                              ].join("\n")
                            },
                            {
                              headers: { "Content-Type": "application/json" },
                            }
                          ).then(res=>{
                            console.log(res);
                            if(window.confirm('order placed. clear the cart?')){
                              clearCart();
                            }
                          }).catch(err=>{
                            console.log(err);
                          });
                          // setStatus("sent");
                          // setValues({ name: "", email: "", subject: "", message: "" });
                        // } catch (err) {
                        //   console.error(err);
                        //   // const msg =
                        //   //   err?.response?.data?.error ||
                        //   //   err?.message ||
                        //   //   "An unexpected error occurred";
                        //   // setErrorMsg(msg);
                        //   // setStatus("error");
                        // }

                      // return axios_with_token(placeOrderUrl, {
                      //     method: "post",
                      //     data: {
                      //       "name": "Martin",
                      //       "email": "martin@willowest.com",
                      //       "subject": "new order from wwapp",
                      //       "message": "new order"
                      //     },
                      //     withCredentials: true,
                      //     headers: { 
                      //         "Content-Type": "multipart/form-data",
                      //         // "Content-Type": "application/x-www-form-urlencoded",
                      //         "Access-Control-Allow-Credentials": "true",
                      //         // "Access-Control-Allow-Origin": bkendUrl,    
                      //         // "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE",    
                      //         // "Access-Control-Allow-Headers": "X-Requested-With,content-type",
                      //         "Cache-Control": "no-cache",
                      //         // "Content-Type": "application/x-www-form-urlencoded",
                      //         // withCredentials: true
                      //         // Cookie: ['x-auth-token-'+jsonPath, Cookies.get('x-auth-token-'+jsonPath)].join('='),
                      //     }
                      // }).then(res=>{
                      //   console.log('res:', res);

                      // }).catch(err=>{
                      //   console.log('err:', err);
                      // });

                  }



                }}
              >
                Place order <i className="bi bi-arrow-right"></i>
              </button>
            </div>

            <div className="continue-shopping">
              <Link
                className="btn btn-link w-100"
                to={`${rootUrl}/wwapp/category`}
              ><i className="bi bi-arrow-left"></i> Continue Shopping</Link>
            </div>

            <div className="payment-methods">
              <p className="payment-title">We Accept</p>
              <div className="payment-icons">
                <i className="bi bi-credit-card"></i>
                <i className="bi bi-paypal"></i>
                <i className="bi bi-wallet2"></i>
                <i className="bi bi-bank"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </section></>
  
  {/* <!-- /Cart Section --> */}
}

export default function Cart(){
    return <Layout>
      <CartContent></CartContent>
    </Layout>

}